export default {
  areaCode: "",
  dataArea: null,
  firstName: "",
  lastName: "",
  tel: "",
  username: "",
  password: "",
};
